module.exports = __webpack_public_path__ + "img/ic_set_username.15147e73.svg";